const breakpoints = {
    base: '0em',
    sm: '480px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    '2xl': '1536px',
    max: '2560px'
}

export default breakpoints
